const HeaderStyle = {
  desktopNav:
    "hidden lg:flex items-center gap-x-4 text-font font-medium tracking-wide  ",
  mobileNav:
    "absolute top-0 left-0 bg-white min-h-[100vh] w-[60vw] z-[100] py-20 px-4 shadow-2xl transition ease-in duration-300  flex flex-col  gap-10 text-2xl",
};

export default HeaderStyle;
